import React from "react";
import { useTranslation } from "react-i18next";
import { truncateText } from "../../Utils";

const RewardProduct = ({ product }) => {
  const { t } = useTranslation();
  return (
    <a
      href={`rewards-product/${product.id}`}
      className="flex border border-gray-200 rounded-lg p-4"
    >
      <div className="flex flex-col flex-auto gap-4">
        {product.imageUrl ? (
          <div className="relative rounded-md w-full h-auto aspect-video overflow-hidden">
            <img
              className="absolute object-contain w-full h-full z-10"
              src={product.imageUrl}
              alt="Product"
              loading="lazy"
            />
            <div
              className="absolute w-full h-full bg-fill blur-[50px] brightness-90 mask-gradient"
              style={{
                backgroundImage: `url('${product.imageUrl}')`,
              }}
            />
          </div>
        ) : (
          <div className="rounded-md w-full h-auto aspect-video text-center overflow-hidden bg-gray-200 text-sm text-gray-500 flex flex-col justify-center">
            {t("No Image")}
          </div>
        )}
        <div className="flex flex-col gap-1">
          <div className="flex flex-col">
            {product.basePoint && product.basePoint > product.point ? (
              <span className="text-xs line-through text-gray-400">
                {product.basePoint?.toLocaleString("id-ID")} {t("point")}
              </span>
            ) : null}
            <span className="text-sm font-medium text-blue-600">
              {product.point?.toLocaleString("id-ID")} {t("point")}
            </span>
          </div>
          <div>
            <h3 className="text-sm font-bold text-gray-900 text-left line-clamp-2">
              {product.name}
            </h3>
          </div>
          <div>
            <p className="text-sm text-gray-900 text-left line-clamp-2">
              {truncateText(product.description, 300)}
            </p>
          </div>
        </div>
      </div>
    </a>
  );
};

export default RewardProduct;
